import React, { useEffect } from "react";
import { motion } from "framer-motion";
import type { QuizWho } from "./types";

export interface QuizWelcomeProps {
  who: QuizWho | "";
  nameDisplay: string;
  onNext: () => void;
}

const captionYour =
  "Let's start with a few questions so we can get to know you better.";
const captionOther =
  "Let's start with a few questions so we can get to know them better.";

export const QuizWelcome: React.FC<QuizWelcomeProps> = ({
  who,
  nameDisplay,
  onNext,
}) => {
  const title =
    who === "your"
      ? `Kia ora, ${nameDisplay}! We're looking forward to helping you.`
      : `We're looking forward to helping ${nameDisplay}.`;
  const caption = who === "your" ? captionYour : captionOther;

  // enter key should trigger the next button
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        onNext();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
  }, [onNext]);

  return (
    <motion.li
      className="step"
      data-step="welcome"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="quiz-inner">
        <div className="quiz-title" data-question-type="title">
          <h2>{title}</h2>
        </div>
        <div className="quiz-caption" data-question-type="caption">
          <p>{caption}</p>
        </div>
      </div>
    </motion.li>
  );
};
